package game

enum class CellState { EMPTY, RED, YELLOW }
